export default __webpack_public_path__ + "static/media/eight_of_cups.c28fc651.png";